import { AxiosResponseHeaders } from 'axios';
import { CardTransactionsResponseBody } from '../../../types';
import { CardTransaction, CardTransactionsResponseDTO } from '../entities/CardTransaction';

export const cardTransactionsResponseDTOToCardTransactionsAdapter = (
  data: CardTransactionsResponseDTO,
  header?: AxiosResponseHeaders,
): CardTransactionsResponseBody => {
  if (!data.body) {
    throw new Error();
  }

  const { cardPaymentTransactions } = data.body;

  const transactions = cardPaymentTransactions.map(
    transaction =>
      new CardTransaction(
        transaction.paymentTransactionDates.find(
          ({ paymentTransactionDateType }) => paymentTransactionDateType === 'ValueDate',
        )?.date!,
        transaction.paymentTransactionDates.find(
          ({ paymentTransactionDateType }) => paymentTransactionDateType === 'PostingDate',
        )?.date!,
        transaction?.merchantInfo?.name ?? '-',
        transaction.paymentTransactionStatus,
        transaction.transactionIdentifications.find(
          ({ transactionIdentificationType, identifier }) =>
            transactionIdentificationType === 'UniqueTransactionIdentifier' && identifier.issuingAuthority === 'DXB',
        )?.identifier.value!,
        transaction.amounts.find(
          ({ cardPaymentTransactionAmountType }) => cardPaymentTransactionAmountType === 'GrossAmount',
        )?.amount!,
        transaction.amounts.find(
          ({ cardPaymentTransactionAmountType }) => cardPaymentTransactionAmountType === 'PrincipalAmount',
        )?.amount!,
        transaction.cardPaymentAuthorizations.find(
          ({ authorizationName }) => authorizationName === 'rrn',
        )?.authorizationCode!,
        transaction?.merchantInfo?.country ?? '-',
        transaction.debitCreditDirection,
        transaction.transactionIdentifications,
      ),
  );
  return {
    transactions,
    pagination: data.pagination,
  };
};
